import { useEffect, useState } from "react";
import { _CompetitionType, _DocumentFactory, _Entailment, _MacroProcess, _single, _SubMacroProcess } from "../../../../core/services/dataBean/EntityCatalog";

import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { PrintObjectJson } from "../../../theme/Component/PrintObjectJson";
import { DocumentViewer } from "../../../theme/Component/DocumentViewer";
import { _UBLPayment } from "../../../../core/services/dataBean/EntityCatalogVdos";

interface Props {
    idUBLInvoice: any;
    issueDate: any;
}

export const UBLPayment = ({ idUBLInvoice, issueDate }: Props) => {

    const ubl = useDataBean(_UBLPayment);
    const _documentos = useDataBean(_DocumentFactory);
    const single = Singleton.getInstance();
    const [docs, setDocs] = useState<any>([]);
    const [lista, setLista] = useState<any>([]);
    const [modalverdoc, setModalverdoc] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idUBLInvoice, issueDate])
    useEffect(() => {
        if (modalverdoc.view) {
            verDocumentos();
        }
    }, [modalverdoc.view]);
    const getLista = () => {

        ubl.instance.getUBLPaymentCatalog(idUBLInvoice, issueDate).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    //console.log(resp)
                }
            }
        )

    }
    const verDocumentos = () => {

        if (ubl.bean.IDDocument) {
            _documentos.instance.getPdfAccountantDocument(ubl.bean.IDDocument, null, ubl.bean.DocumentDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocs(resp.DocumentURL);

                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const create = () => {
        ubl.setBean({

        });
        setModal({ ...modal, "view": true });
    }


    const head = [
        { title: 'ID', property: 'IDUBLPayment', visible: true },
        { title: 'Tipo Documento', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Fecha Documento', property: 'DocumentDate', visible: true },
        { title: 'Valor Pagado', property: 'PaymentValue', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'ID Factura UBL', property: 'IDUBLInvoice', visible: true },
        { title: 'Fecha Factura UBL', property: 'IssueDate', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Ver Documento', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalverdoc({ ...modalverdoc, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">

            <BasicPage titulo="Pagos de la factura">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={ubl.setBean} listButtons={listaBotones()}></BasicTable>

                </div>
                <div className="col-md-12">
                    <Modal modal={modalverdoc} updateModal={setModalverdoc}>
                        <div className="row">
                            <div className="col-md-12">
                                <DocumentViewer
                                    list={docs}
                                    IDDocument={ubl.bean.IDDocument}
                                    Since={ubl.bean.DocumentDate}
                                />
                            </div>
                        </div>
                    </Modal>
                </div>
            </BasicPage>
        </div>
    )
}